import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, retry, switchMap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { TurnstileService } from '../services/turnstile.service';

const TURNSTILE_HEADER = 'X-Turnstile-Token';
const TURNSTILE_REJECT_STATUS = 403;

export const turnstileInterceptor: HttpInterceptorFn = (request, next) => {
  const turnstileService = inject(TurnstileService);

  if (!isPublicRequest(request)) {
    return next(request);
  }

  return sendWithToken(turnstileService, request, next, false);
};

function isPublicRequest(request: HttpRequest<unknown>): boolean {
  const publicUrl = `${environment.backEndUrl}/public/`;
  return request.url.startsWith(publicUrl);
}

function sendWithToken(
  turnstileService: TurnstileService,
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  isRetry: boolean,
): Observable<HttpEvent<unknown>> {
  return turnstileService.getToken().pipe(
    // One silent retry for transient widget hiccups (a challenge that
    // errored while Cloudflare's retry:'auto' cycles to a fresh attempt).
    retry({ count: 1, delay: () => timer(200) }),
    switchMap((token: string) => {
      const req = token ? request.clone({ setHeaders: { [TURNSTILE_HEADER]: token } }) : request;
      return next(req).pipe(
        catchError((err: unknown) => {
          if (
            !isRetry &&
            err instanceof HttpErrorResponse &&
            err.status === TURNSTILE_REJECT_STATUS &&
            token
          ) {
            return sendWithToken(turnstileService, request, next, true);
          }
          return throwError(() => err);
        }),
      );
    }),
  );
}
